import { useProduct } from "contexts/ProductContext";
import { ListLoading } from "components/skeletons/ListLoading";
import { Text } from "components/text";
import { useTranslation } from "react-i18next";
import { useProductActions } from "hooks/useProductActions";
import { actionInProgress } from "utils/status";
import { EmptyList } from "components/empty/EmptyList";
import { Button } from "components/button";
import { BasePanel } from "components/BasePanel";
import { useSubjectsData } from "./SubjectsList";
import { Codes } from "./Codes";

export const GeneratedCodes = () => {
  const { product } = useProduct();
  const { t } = useTranslation(["productDetails"]);
  const { generateProductSubjects } = useProductActions();
  const { isEmptyList: isEmptySubjectsList } = useSubjectsData(
    "generated",
    product,
  );

  const { isEmptyList: isEmptyQualifiersList } = useSubjectsData(
    "generated",
    product,
  );

  const isGeneratingProduct = actionInProgress(
    product?.actions?.thema?.actions?.generate,
  );

  if (isGeneratingProduct) {
    return (
      <BasePanel
        title={t("thema.tabs.generated")}
        className="h-full"
        wrapper={false}
      >
        <div className="flex items-center justify-center p-6 h-full">
          <div className="items-center flex flex-col">
            <div className="relative w-59 h-20">
              <ListLoading />
            </div>
            <Text variant="label" className="text-center">
              {t("thema.loading")}
            </Text>
          </div>
        </div>
      </BasePanel>
    );
  }

  return (
    <BasePanel
      isEmpty={isEmptySubjectsList && isEmptyQualifiersList}
      emptyComponent={
        <div className="h-full items-center justify-center flex">
          <EmptyList
            title={t("thema.generateTitle")}
            text={t("thema.generateDescription")}
            orientation="vertical"
            buttons={[
              <Button
                key="button_generate_keywords"
                label={t("general:buttons.generate")}
                icon="sparkles"
                onClick={() => generateProductSubjects(product?.id || "")}
                size="small"
                analyticsId="button_generate_keywords"
              />,
            ]}
          />
        </div>
      }
      title={t("thema.tabs.generated")}
      className="h-full"
      testId="generated-codes"
    >
      <Codes variant="generated" />
    </BasePanel>
  );
};
